import { createAvailabilityService } from '@shared/api/availability.service'
import { authorizedHttpClient } from './http-client'

export const AvailabilityService = createAvailabilityService(authorizedHttpClient, import.meta.env.VITE_API_URL)
